/**
 * [骑手投保配置]
 * @author: Fu Xiaochun
 * @date: 2022-07-18 
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Modal, message, Table, } from 'antd';
import * as apis from '@/apis/system/params';
import { tooltipStyle, tooltip } from '@/components/TableCell';

function RiderInsuranceConfig(){

    const [listData, setListData] = useState([]);

    

    useEffect(()=>{
        onSearch();
    }, []);

    const onSearch = ()=>{
        apis.riderInsuranceList().then(res=>{
            setListData(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    // 保险状态更新  开启/关闭
    const updateInsuranceStatus = (params)=>{
        apis.updateRiderInsuranceStatus(params).then(res=>{
            message.success('操作成功！');
            onSearch();
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const tableAction = (type, item)=>{
        switch (type){
            case 'turnOn':
                Modal.confirm({
                    centered: true,
                    title: '确定开启此保险吗？',
                    onOk: ()=>{updateInsuranceStatus({id: item.id, status: item.status === '0' ? '1' : '0'});}
                });
                break;
            case 'turnOff':
                Modal.confirm({
                    centered: true,
                    title: '确定关闭此保险吗？',
                    onOk: ()=>{updateInsuranceStatus({id: item.id, status: item.status === '1' ? '0' : '1'});}
                });
                break;
            default:
                // nothing to do
        }
    };

    const actionHandle = (id, record)=>{
        return (
            < div className={styles.action} >
                {record.status === '1' && <div className={styles.item} onClick={() => tableAction('turnOff', record)}>去关闭</div>}
                {record.status === '0' && <div className={styles.item} onClick={() => tableAction('turnOn', record)}>去开启</div>}
            </div >
        );
    };

    const statusName = (key)=>{
        let statusEnums = ['未开启', '已开启'];
        return statusEnums[parseInt(key)];
    };

    const columns = [
        {
            title: '保险通道',
            dataIndex: 'insureName',
            key: 'insureName',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '保险产品',
            dataIndex: 'productName',
            key: 'productName',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '投保状态',
            dataIndex: 'status',
            key: 'status',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: statusName
        },
        {
            title: '最近一次操作时间',
            dataIndex: 'gmtModified',
            key: 'gmtModified',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作人',
            dataIndex: 'modifyUserName',
            key: 'modifyUserName',
            width: '120px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '80px',
            fixed: 'right',
            render: actionHandle,
        }
    ];

    return (
        <div className={styles.tableContainer}>
            <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={listData}
                    pagination={false}
                    scroll={{ y: true }}
                />
        </div>
    );
}

export default RiderInsuranceConfig;